// ── Selected Projects Section Editor (Transition Page) ─────────────────────────
// Full-width dark background, centered title, subtitle, gold divider

export default function SelectedProjectsSection({ data, onChange }) {
  const intro = data || {};

  const update = (key, value) => {
    onChange({ ...intro, [key]: value });
  };

  return (
    <div className="space-y-4">
      {/* Title */}
      <div>
        <label className="block text-xs font-semibold text-[#6b7280] uppercase tracking-wider mb-1">
          Title
        </label>
        <input
          type="text"
          value={intro.title || ''}
          onChange={(e) => update('title', e.target.value)}
          placeholder="SELECTED PROJECTS"
          className="w-full px-3 py-2 text-sm border border-[#e5e4df] rounded-md focus:outline-none focus:ring-1 focus:ring-[#c9a84c] focus:border-[#c9a84c] bg-white font-semibold tracking-wider"
        />
      </div>

      {/* Subtitle */}
      <div>
        <label className="block text-xs font-semibold text-[#6b7280] uppercase tracking-wider mb-1">
          Subtitle
        </label>
        <textarea
          value={intro.subtitle || ''}
          onChange={(e) => update('subtitle', e.target.value)}
          placeholder="A showcase of our recent commercial fit-out projects..."
          rows={3}
          className="w-full px-3 py-2 text-sm border border-[#e5e4df] rounded-md focus:outline-none focus:ring-1 focus:ring-[#c9a84c] focus:border-[#c9a84c] bg-white"
        />
      </div>

      {/* Preview */}
      <div className="mt-4">
        <label className="block text-xs font-semibold text-[#6b7280] uppercase tracking-wider mb-2">
          Preview
        </label>
        <div
          className="rounded-lg p-8 flex flex-col items-center justify-center text-center"
          style={{
            background: 'linear-gradient(135deg, #1a1a2e 0%, #2d2d52 100%)',
            minHeight: '160px',
          }}
        >
          <h3
            className="text-2xl font-bold text-[#c9a84c] tracking-widest mb-3"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            {intro.title || 'SELECTED PROJECTS'}
          </h3>
          <div className="w-16 h-0.5 bg-[#c9a84c] mb-3" />
          <p className="text-white/70 text-sm max-w-md leading-relaxed">
            {intro.subtitle || 'A showcase of our recent commercial fit-out projects demonstrating our capability and commitment to excellence.'}
          </p>
        </div>
      </div>
    </div>
  );
}
